import axios from 'axios';

const SNAP_TO_ROADS_API_URL = 'https://roads.googleapis.com/v1/snapToRoads';
const API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;

/**
 * Snaps GPS coordinates to the nearest road segments
 * @param {Array<{lat: number, lng: number}>} coordinates - Array of GPS coordinates
 * @param {boolean} interpolate - Whether to interpolate a path to include all points forming the full road geometry
 * @returns {Promise<Array<{lat: number, lng: number}>>} Array of snapped coordinates
 */
const snapToRoads = async (coordinates, interpolate = true) => {
  try {
    // Format path parameter: lat1,lng1|lat2,lng2|...
    const path = coordinates.map((coord) => `${coord.lat},${coord.lng}`).join('|');

    const params = new URLSearchParams({
      key: API_KEY,
      interpolate: interpolate.toString(),
      path: path,
    });

    const response = await axios.get(`${SNAP_TO_ROADS_API_URL}?${params.toString()}`);

    // Extract snapped points from the response
    const snappedPoints = response.data?.snappedPoints || [];

    if (snappedPoints.length === 0) {
      return [];
    }

    const snappedCoordinates = snappedPoints
      .map((point) => {
        const location = point.location || {};
        return {
          lat: location.latitude || point.lat,
          lng: location.longitude || point.lng,
        };
      })
      .filter((coord) => coord.lat && coord.lng);

    return snappedCoordinates;
  } catch (error) {
    console.error('Error snapping to roads:', error);
    if (error.response) {
      console.error('API Error:', error.response.data);
    }
    throw error;
  }
};

export { snapToRoads };
